import { MICROSERVICES_API_BASE_URL } from '../config';

export const PermissionAPIRoutes = {
  getPermissionData: () => `${MICROSERVICES_API_BASE_URL}/life-permissions`,
};
